<template>
  <div>
    <b-row>

      <b-col>
        <b-card class="h-100">
          <label class="btn w-100 mt-4 alert alert-dark" v-if="!powerOfAttorney">
            {{ $t('message.adminUserDocuments.uploadPoa') }}
            <input type="file" hidden @change="uploadPoa" accept="application/pdf, image/*">
          </label>

          <b-row>
            <b-col>
              <b-btn
                v-if="powerOfAttorney"
                variant="transparent"
                @click="downloadPowerOfAttorney"
                class="p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate">
                <b-alert
                  show
                  variant="dark"
                  class="rounded-0 certificate pb-0 mb-0">
                  <p>
                    <span class="ti-printer mr-2"></span>
                    {{ $t('message.adminUserDocuments.viewPoa') }}
                  </p>
                </b-alert>
              </b-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <b-btn
                v-if="powerOfAttorney"
                variant="danger"
                v-b-modal.delete-poa-modal
                class="mt-3">
                {{ $t('message.adminUserDocuments.deleteDocument') }}
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col>
        <b-card class="h-100">
          <label class="btn w-100 mt-4 alert alert-dark" v-if="!certificateOfDeath">
            {{ $t('message.adminUserDocuments.uploadCod') }}
            <input type="file" hidden @change="uploadCertificateOfDeath" accept="application/pdf, image/*">
          </label>

          <b-row>
            <b-col>
              <b-btn
                v-if="certificateOfDeath"
                variant="transparent"
                @click="downloadCertificateOfDeath"
                class="p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate">
                <b-alert
                  show
                  variant="dark"
                  class="rounded-0 certificate pb-0 mb-0">
                  <p>
                    <span class="ti-printer mr-2"></span>
                    {{ $t('message.adminUserDocuments.viewCod') }}
                  </p>
                </b-alert>
              </b-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <b-btn
                v-if="certificateOfDeath"
                variant="danger"
                v-b-modal.delete-cod-modal
                class="mt-3">
                {{ $t('message.adminUserDocuments.deleteDocument') }}
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col>
        <b-card class="h-100">

          <b-form-select
            class="mt-4"
            v-model="selected"
            :options="options"
            @change="selectCp">
          </b-form-select>

          <label class="btn w-100 mt-4 alert alert-dark" v-if="!certificateOfInheritance && selected">
            {{ $t('message.adminUserDocuments.uploadCoi') }}
            <input type="file" hidden @change="uploadCertificateOfInheritance" accept="application/pdf">
          </label>

          <b-row>
            <b-col>
              <b-btn
                v-if="certificateOfInheritance"
                variant="transparent"
                @click="downloadCertificateOfInheritance"
                class="p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate">
                <b-alert
                  show
                  variant="dark"
                  class="rounded-0 certificate pb-0 mb-0">
                  <p>
                    <span class="ti-printer mr-2"></span>
                    {{ $t('message.adminUserDocuments.viewCoi') }}
                  </p>
                </b-alert>
              </b-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <b-btn
                v-if="certificateOfInheritance"
                variant="danger"
                v-b-modal.delete-coi-modal
                class="mt-3">
                {{ $t('message.adminUserDocuments.deleteDocument') }}
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

    </b-row>

    <b-modal id="delete-cod-modal"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.adminUserDocuments.modal.title')"
             :ok-title="$t('message.adminUserDocuments.modal.btn.ok')"
             :cancel-title="$t('message.adminUserDocuments.modal.btn.cancel')"
             @ok="deleteCertificateOfDeath">
      <p class="mt-4">{{ $t('message.adminUserDocuments.modal.message') }}</p>
    </b-modal>
    <b-modal id="delete-coi-modal"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.adminUserDocuments.modal.title')"
             :ok-title="$t('message.adminUserDocuments.modal.btn.ok')"
             :cancel-title="$t('message.adminUserDocuments.modal.btn.cancel')"
             @ok="deleteCertificateOfInheritance">
      <p class="mt-4">{{ $t('message.adminUserDocuments.modal.message') }}</p>
    </b-modal>
    <b-modal id="delete-poa-modal"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.adminUserDocuments.modal.title')"
             :ok-title="$t('message.adminUserDocuments.modal.btn.ok')"
             :cancel-title="$t('message.adminUserDocuments.modal.btn.cancel')"
             @ok="deletePowerOfAttorney">
      <p class="mt-4">{{ $t('message.adminUserDocuments.modal.message') }}</p>
    </b-modal>
  </div>
</template>

<script>
  import b64toBlob from 'b64-to-blob'
  import utils from '@/utils'

  export default {
    name: 'AdminUserDocuments',
    created () {
      this.$store.commit('setAdminCertificateOfInheritance', null)
      this.$store.dispatch('fetchAdminPowerOfAttorney', this.userId)
      this.$store.dispatch('fetchAdminCertificateOfDeath', this.userId)
    },
    computed: {
      certificateOfDeath () {
        return this.$store.getters.adminCertificateOfDeath
      },
      certificateOfInheritance () {
        return this.$store.getters.adminCertificateOfInheritance
      },
      options () {
        const contactPersons = this.$store.getters.adminContactPersons
        if (!contactPersons) return [{value: null, text: this.$t('message.adminUserDocuments.noPH')}]
        const options = contactPersons.map(cp => {
          var option = {}
          option['value'] = cp.id
          option['text'] = cp.firstName + ' ' + cp.lastName
          return option
        })
        options.unshift({value: null, text: this.$t('message.adminUserDocuments.selectCP')})
        return options
      },
      powerOfAttorney () {
        return this.$store.getters.adminPowerOfAttorney
      },
      userId () {
        return parseInt(this.$route.params.id)
      }
    },
    data () {
      return {
        selected: null
      }
    },
    methods: {
      deleteCertificateOfDeath () {
        this.$store.dispatch('deleteAdminCertificateOfDeath', this.userId)
      },
      deleteCertificateOfInheritance () {
        this.$store.dispatch('deleteAdminCertificateOfInheritance', {
          policyHolderId: this.userId,
          cpId: this.selected
        })
      },
      deletePowerOfAttorney () {
        this.$store.dispatch('deleteAdminPowerOfAttorney', this.userId)
      },
      downloadCertificateOfDeath () {
        utils.download(this.certificateOfDeath)
      },
      downloadCertificateOfInheritance () {
        const certificateOfInheritance = this.certificateOfInheritance
        if (certificateOfInheritance) {
          const contentType = 'application/pdf'
          const blob = b64toBlob(certificateOfInheritance.file, contentType)
          utils.downloadBlob(blob, this.$t('message.policyHolderDetails.certificateOfInheritance'))
        }
      },
      downloadPowerOfAttorney () {
        utils.download(this.powerOfAttorney)
      },
      uploadCertificateOfDeath (event) {
        const file = event.target.files[0]
        if (file) {
          this.$store.dispatch('uploadAdminCertificateOfDeath', {
            policyHolderId: this.userId,
            certificateOfDeath: file
          }).then(() => {
            this.showSuccessMsg({
              message: this.$t('message.policyHolderDetails.uploadCertificateOfDeath')
            })
          }).catch(() => {
            this.showErrorMsg({
              message: this.$t('error.policyHolderDetails.uploadCertificateOfDeath')
            })
          })
        }
      },
      uploadCertificateOfInheritance (event) {
        const file = event.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => {
            const base64Value = reader.result.split(',')[1]
            this.$store.dispatch('uploadAdminCertificateOfInheritance', {
              policyHolderId: this.userId,
              cpId: this.selected,
              file: file,
              documents: {
                certificateOfInheritance: base64Value
              }
            }).then(() => {
              this.showSuccessMsg({
                message: this.$t('message.policyHolderDetails.uploadCertificateOfInheritance')
              })
            }).catch(() => {
              this.showErrorMsg({
                message: this.$t('error.policyHolderDetails.uploadCertificateOfInheritance')
              })
            })
          }
          reader.onerror = () => {
            this.showErrorMsg({
              message: this.$t('error.policyHolderDetails.fileReaderError')
            })
          }
        }
      },
      uploadPoa (event) {
        const file = event.target.files[0]
        if (file) {
          this.loading = true
          this.$store.dispatch('uploadAdminPowerOfAttorney', {
            policyHolderId: this.userId,
            powerOfAttorney: file
          }).then(() => {
            this.showSuccessMsg({
              message: this.$t('message.accountPowerOfAttorneyForm.uploadSuccess')
            })
          }).catch(() => {
            this.showErrorMsg({
              message: this.$t('error.accountPowerOfAttorneyForm.uploadFailure')
            })
          }).finally(() => {
            this.loading = false
          })
        }
      },
      selectCp (event) {
        this.$store.dispatch('fetchAdminCertificateOfInheritance', {
          policyHolderId: this.userId,
          cpId: event
        })
      }
    },
    notifications: {
      showSuccessMsg: {
        type: 'success'
      },
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUserDocuments.vue